(() => {

    var $ = require( "jquery" );

    let knowHowFilter = {

        init: () => {

            knowHowFilter.addEventListeners();

        },

        addEventListeners: () => {

            $("[data-function-id]").on('click', function() {
                $(this).toggleClass("active");

                knowHowFilter.filterArticles();

            });

        },

        getActiveFilters: () => {

            let activeFilters = [];

            $("[data-function-id]").each( function() {
                    
                if( $(this).hasClass('active') ) {
                    activeFilters.push( parseInt( $(this).data('function-id') ) );
                }

            });

            return activeFilters;

        },

        filterArticles: () => {

            let activeFilters = knowHowFilter.getActiveFilters();

            $("[data-functions]").each( function() {
                if( activeFilters.length == 0 ) {
                    $(this).removeClass("!hidden");
                    return;
                }

                $(this).toggleClass("!hidden", ! activeFilters.some( activeFilter => $(this).data('functions').includes(activeFilter) ) );
            });

        }

    };

    $(document).ready( knowHowFilter.init );

})();